'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var DEFAULT_CONFIG = exports.DEFAULT_CONFIG = {
  URI: 'https://api.hundredrooms.com/price',
  RATING_PRICES_RANGE: {
    'de-de': { MIN: 50, MAX: 250 },
    'en-au': { MIN: 20, MAX: 80 },
    'en-gb': { MIN: 50, MAX: 300 },
    'en-us': { MIN: 80, MAX: 250 },
    'es-ar': { MIN: 560, MAX: 1680 },
    'es-cl': { MIN: 10000, MAX: 40000 },
    'es-co': { MIN: 40000, MAX: 140000 },
    'es-es': { MIN: 80, MAX: 140 },
    'es-mx': { MIN: 800, MAX: 4000 },
    'es-pe': { MIN: 50, MAX: 180 },
    'es-uy': { MIN: 2000, MAX: 8000 },
    'fr-fr': { MIN: 62.5, MAX: 250 },
    'it-it': { MIN: 40, MAX: 120 },
    'ja-jp': { MIN: 7500, MAX: 22500 }
  }
};

var CULTURE_FALLBACK = exports.CULTURE_FALLBACK = {
  'de-de': 'de-de',
  'en-au': 'en-gb',
  'en-gb': 'en-gb',
  'en-us': 'en-gb',
  'es-ar': 'es-es',
  'es-cl': 'es-es',
  'es-co': 'es-es',
  'es-es': 'es-es',
  'es-mx': 'es-es',
  'es-pe': 'es-es',
  'es-uy': 'es-es',
  'fr-fr': 'fr-fr',
  'it-it': 'it-it',
  'ja-jp': 'en-gb'
};

var VERSION = exports.VERSION = 'v1';

var ORDERING = exports.ORDERING = {
  ORDER_NONE: 0,
  ORDER_BY_RATING: 1,
  ORDER_BY_PRICE_ASC: 2,
  ORDER_BY_PRICE_DESC: 3,
  ORDER_BY_HOT_DEALS: 4
};

var AVAILABILITY = exports.AVAILABILITY = {
  INSTANTLY: 1,
  UNDER_DEMAND: 2,
  UNCONFIRMED: 3
};

var BASE_IMG_PATH = exports.BASE_IMG_PATH = '/img/clickout/';

var EVENTS = exports.EVENTS = {
  ERROR: 'error',
  START: 'start',
  COMPLETE: 'complete',
  PROGRESS: 'progress'
};

var HTTP_RESPONSES = exports.HTTP_RESPONSES = {
  OK: 200,
  ACCEPTED: 202,
  NO_CONTENT: 204,
  FINISHED: 299
};

var PRICE_FILTER_TYPE = exports.PRICE_FILTER_TYPE = {
  DAY: 1,
  TOTAL: 2
};

var SERVICES = exports.SERVICES = {
  SERVICE_TOWELS: 1,
  SERVICE_KITCHEN: 2,
  SERVICE_WIFI: 3,
  SERVICE_INTERNET: 4,
  SERVICE_CABLE_TV: 5,
  SERVICE_TV: 6,
  SERVICE_PARKING: 7,
  SERVICE_AIR_CONDITIONING: 8,
  SERVICE_LAUNDRY: 9,
  SERVICE_FREE_CLEANING: 10,
  SERVICE_HANDICAPPED: 11,
  SERVICE_SWIMMING_POOL: 12,
  SERVICE_GYM: 13,
  SERVICE_BREAKFAST: 14,
  SERVICE_LIFT: 15,
  SERVICE_DOORMAN: 16,
  SERVICE_BALCONY: 17,
  SERVICE_OUTDOOR_SPACE: 18,
  SERVICE_CRADLE: 19,
  SERVICE_HEAT: 20,
  SERVICE_PETS: 21
};

var ESTABLISHMENT_TYPE = exports.ESTABLISHMENT_TYPE = {
  APARTMENT: 1,
  HOTEL: 2,
  HOUSE: 3,
  ROOM: 4,
  APARTHOTEL: 5
};

var RATING = exports.RATING = {
  RECOMMENDATION_FACTOR: 400,
  CPC_FACTOR: 155,
  PRICE_FACTOR: 96,
  MAX_DISCOUNT: 60,
  DISCOUNT_FACTOR: 60,
  INSTANTBOOKING_FACTOR: 600,
  NUMBER_PRICES_FACTOR: 11.5,
  POLYGON_FACTOR: 1274,
  QUALITY_SCORE: { 12: 1 },
  CANCELLATION_POLICY: 0,
  BOOKING_BOOST: 75,
  HOTEL_FACTOR: 2970
};

var RANKING_LOW_LIMIT = exports.RANKING_LOW_LIMIT = {
  POSITIVE: 3.5,
  NEUTRAL: 2,
  NEGATIVE: 0
};

var CANCELLATION_POLICY = exports.CANCELLATION_POLICY = {
  FULL: 'full',
  PARTIAL: 'partial'
};

var ESTAB = exports.ESTAB = 'ESTAB';
var VACATION_RENTAL = exports.VACATION_RENTAL = 'VACATION_RENTAL';
var HOTEL = exports.HOTEL = 'HOTEL';

var ESTAB_OFFER = exports.ESTAB_OFFER = 'PRICE';
var VACATION_RENTAL_OFFER = exports.VACATION_RENTAL_OFFER = 'VACATION_RENTAL_OFFER';
var HOTEL_OFFER = exports.HOTEL_OFFER = 'HOTEL_OFFER';

var PROPERTY_TYPES = exports.PROPERTY_TYPES = [ESTAB, VACATION_RENTAL, HOTEL];

var OFFER_TYPES = exports.OFFER_TYPES = [ESTAB_OFFER, VACATION_RENTAL_OFFER, HOTEL_OFFER];

var CATEGORY_LITERALS = exports.CATEGORY_LITERALS = {
  1: 'Apartment',
  2: 'Hotel',
  3: 'House',
  4: 'Room',
  5: 'Aparthotel'
};

var PARTNER_IDS = exports.PARTNER_IDS = {
  ROOMORAMA: 1,
  BOOKING: 2,
  MIGOA: 3,
  HOUSETRIP: 4,
  NFLATS: 5,
  WAYTOSTAY: 6,
  GOWITHOH: 7,
  HOTELESCOM: 8,
  AIRBNB: 9,
  HABITATAPARTMENTS: 10,
  INTERHOME: 11,
  HOMEAWAY: 12,
  BEMATE: 13,
  BEDYCASA: 14,
  ONLYAPARTMENTS: 15,
  EDOMIZIL: 16,
  FLIPKEY: 17,
  WIMDU: 18,
  RENTALIA: 19,
  ALTERKEYS: 20,
  MAGICSTAY: 21,
  MUCHOSOL: 22,
  ATRAPALO: 23,
  INTERCHALET: 24,
  FERIES: 25,
  HOMELIDAYS: 26,
  TOPRURAL: 27,
  ADRIATIC: 28,
  BELVILLA: 29,
  TRIVAGO: 30,
  AGODA: 31
};

var MIN_DISCOUNT_VALUE = exports.MIN_DISCOUNT_VALUE = 10;
var MAX_DISCOUNT_VALUE = exports.MAX_DISCOUNT_VALUE = 70;
var HOTEL_CATEGORIES = exports.HOTEL_CATEGORIES = [ESTABLISHMENT_TYPE.HOTEL, ESTABLISHMENT_TYPE.APARTHOTEL];